<template>
  <b-container>
    <b-row>
      <b-col cols="4">
        <b-card>
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row class="mb-1">
              <b-col cols="12 mb-1">
                <b-badge variant="light-warning" v-if="detail.status === 0">{{
                  detail.status_name
                }}</b-badge>
                <b-badge
                  variant="light-primary"
                  v-else-if="detail.status === 1"
                  >{{ detail.status_name }}</b-badge
                >
                <b-badge
                  variant="light-success"
                  v-else-if="detail.status === 2"
                  >{{ detail.status_name }}</b-badge
                >
              </b-col>
              <b-col md="12">
                <label class="mb-1 text-primary font-weight-bold"
                  >Details Receiving</label
                >
              </b-col>
              <b-col md="12">
                <b-row>
                  <b-col md="6"> Code </b-col>
                  <b-col md="6" class="text-right">
                    {{ detail.code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Code Ref </b-col>
                  <b-col md="6" class="text-right">
                    <div v-if="detail.code_ref === ''">-</div>
                    <div v-else>{{ detail.code_ref }}</div>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Warehouse </b-col>
                  <b-col md="6" class="text-right">
                    {{ detail.warehouse }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Date </b-col>
                  <b-col md="6" class="text-right">
                    {{ moment(detail.date) }}
                  </b-col>
                </b-row>
                <hr v-if="detail.status > 0" />
                <b-row v-if="detail.status > 0">
                  <b-col md="6"> Assign to </b-col>
                  <b-col md="6" class="text-right">
                    {{ detail.assign_to }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
        <b-card v-if="detail.type === 1">
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row class="mb-1">
              <b-col md="12">
                <label class="mb-1 text-primary font-weight-bold"
                  >Details Purchase</label
                >
              </b-col>
              <b-col md="12">
                <b-row>
                  <b-col md="6"> Code </b-col>
                  <b-col md="6" class="text-right">
                    {{ purchase.code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Tax </b-col>
                  <b-col md="6" class="text-right">
                    {{ formatRupiah(purchase.tax) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Additional Cost </b-col>
                  <b-col md="6" class="text-right">
                    {{ formatRupiah(purchase.additional_cost) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Total Price </b-col>
                  <b-col md="6" class="text-right">
                    {{ formatRupiah(purchase.total_price) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Vendor </b-col>
                  <b-col md="6" class="text-right">
                    {{ purchase.vendor }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Date </b-col>
                  <b-col md="6" class="text-right">
                    {{ moment(purchase.date) }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
        <b-card v-if="detail.type === 2">
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row class="mb-1">
              <b-col md="12">
                <label class="mb-1 text-primary font-weight-bold"
                  >Details Transfer</label
                >
              </b-col>
              <b-col md="12">
                <b-row>
                  <b-col md="6"> Code </b-col>
                  <b-col md="6" class="text-right">
                    {{ transfer.code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Warehouse Origin </b-col>
                  <b-col md="6" class="text-right">
                    {{ transfer.warehouse_origin }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Warehouse Destination </b-col>
                  <b-col md="6" class="text-right">
                    {{ transfer.warehouse_destination }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Description </b-col>
                  <b-col md="6" class="text-right">
                    {{ transfer.description }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="6"> Date </b-col>
                  <b-col md="6" class="text-right">
                    {{ moment(transfer.date) }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="8">
        <b-card>
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row>
              <b-col md="12">
                <label for="items" class="text-primary font-weight-bold"
                  >List Items</label
                >
              </b-col>
              <b-col md="12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                  <b-form-group>
                    <div class="d-flex align-items-center">
                      <label class="mr-1">Search</label>
                      <b-form-input
                        v-model="searchTerm"
                        placeholder="Search"
                        type="text"
                        class="d-inline-block"
                      />
                    </div>
                  </b-form-group>
                </div>
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                                    :src="props.row.avatar"
                                                    class="mx-1"
                                                /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">Rp {{ props.row.price }}</span>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span v-if="detail.status === 1">
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            v-b-modal.modal-insert
                            @click="trigger(props.row)"
                            v-if="
                              permissions.includes('warehouse-receiving-update')
                            "
                          >
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>Insert</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({
                                currentPerPage: value,
                              })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
        <b-card v-if="logs.length > 0">
          <app-timeline>
            <app-timeline-item
              v-for="(log, index) in logs"
              :key="index"
              :title="log.description"
              :subtitle="'Insert ' + log.qty + ' Qty'"
              :time="moment(log.created_at)"
              :variant="log.variant"
            />
          </app-timeline>
        </b-card>
        <b-row>
          <b-col
            md="12"
            v-if="
              permissions.includes('warehouse-receiving-update') &&
              detail.status === 0
            "
          >
            <b-button
              class="mt-0"
              type="submit"
              variant="primary"
              block
              v-b-modal.modal-assign
            >
              Process
            </b-button>
          </b-col>
          <b-col
            md="12"
            v-if="
              permissions.includes('warehouse-receiving-update') &&
              detail.status === 1
            "
          >
            <b-button
              class="mt-0"
              type="submit"
              variant="success"
              block
              :disabled="logs.length === 0 ? true : false"
              @click="statusFinish()"
            >
              Finish
            </b-button>
          </b-col>
          <!-- modal Assign -->
          <b-modal
            id="modal-assign"
            title="Assign Form"
            ok-title="Assign"
            cancel-variant="outline-secondary"
            hide-footer
            no-close-on-backdrop
          >
            <validation-observer ref="loginValidation">
              <b-form ref="form" @submit.prevent>
                <b-form-group
                  :state="errors"
                  label="Assign"
                  label-for="assign"
                  invalid-feedback="Assign required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="assign"
                    rules="required"
                  >
                    <v-select
                      id="assign"
                      name="assign"
                      v-model="form.selectedEmployee"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="form.optionsEmployee"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Select Assign"
                      required="required"
                    />
                    <small class="text-danger">{{
                      errors[0] || errMessage
                    }}</small>
                  </validation-provider>
                </b-form-group>

                <b-row>
                  <b-col>
                    <b-button
                      class="mt-3"
                      type="submit"
                      variant="primary"
                      block
                      @click="statusProcess()"
                    >
                      Process
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
          <!-- end modal assign -->
          <!-- modal insert -->
          <b-modal
            id="modal-insert"
            title="Insert Form"
            ok-title="Insert"
            cancel-variant="outline-secondary"
            hide-footer
          >
            <validation-observer ref="loginValidation">
              <b-form ref="form" @submit.prevent>
                <b-form-group
                  :state="errors"
                  label="Bin Location"
                  label-for="bin"
                  invalid-feedback="Bin Location required"
                >
                  <validation-provider name="bin" rules="required">
                    <v-select
                      id="bin"
                      v-model="insert.selectedBin"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="insert.optionsBin"
                      placeholder="Select 1 Bin Location"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!insert.selectedBin"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  :state="errors"
                  label="Qty"
                  label-for="qty"
                  invalid-feedback="Qty required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="qty"
                    rules="required"
                  >
                    <b-form-input
                      id="qty"
                      name="qty"
                      type="number"
                      v-model="insert.qty"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Qty"
                      required="required"
                    />
                  </validation-provider>
                </b-form-group>

                <b-row>
                  <b-col>
                    <b-button
                      class="mt-3"
                      type="submit"
                      variant="primary"
                      block
                      @click="insertItemToBin()"
                    >
                      Insert
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
          <!-- end modal insert -->
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BModal,
  VBModal,
  BAlert,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import moment from "moment";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BAlert,
    BModal,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      form: {
        selectedEmployee: null,
        optionsEmployee: [],
      },
      detail: {
        ref_id: null,
        warehouse_id: null,
        warehouse: "",
        code: "",
        code_ref: "",
        status: null,
        status_name: "",
        type: null,
        date: null,
        assign_to: "",
      },
      purchase: {
        code: "",
        tax: null,
        additional_cost: null,
        total_price: null,
        vendor: "",
        date: null,
      },
      transfer: {
        code: "",
        warehouse_origin: "",
        warehouse_destination: "",
        description: "",
        date: null,
      },
      insert: {
        real_qty: null,
        item_id: null,
        qty: null,
        selectedBin: null,
        optionsBin: [],
        type: null,
        ref_id: null,
      },
      logs: [],
      hasImage: "",
      image: "",
      photo: "",
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Image",
          field: "image",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Unit",
          field: "unit_name",
        },
        {
          label: "Action",
          field: "action",
          width: "100px",
        },
      ],
      permissions: [],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-warning",
        1: "light-primary",
        2: "light-success",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getEmployees();
    this.getLogs();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/receiving/" + id).then((response) => {
        // console.log(response.data.data)
        this.detail.ref_id = response.data.data.ref_id;
        this.detail.code = response.data.data.code;
        this.detail.code_ref = response.data.data.code_ref;
        this.detail.warehouse_id = response.data.data.warehouse_id;
        this.detail.warehouse = response.data.data.warehouse_name;
        this.detail.status = response.data.data.status;
        this.detail.status_name = response.data.data.status_name;
        this.detail.date = response.data.data.created_at;
        this.detail.type = response.data.data.type;
        this.detail.assign_to = response.data.data.assign_name;
        if (this.detail.type === 1) {
          this.getDetailsPurchase();
          this.getDetailsPurchaseItem();
        } else if (this.detail.type === 2) {
          this.getDetailsTransfer();
          this.getDetailsTransferItem();
        }
      });
    },
    getEmployees() {
      this.$http.get("employees").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsEmployee.push($data);
        }
      });
    },
    getDetailsPurchase() {
      this.$http
        .get("procurement/purchase/" + this.detail.ref_id)
        .then((response) => {
          // console.log(response.data.data)
          this.purchase.code = response.data.data.code;
          this.purchase.tax = response.data.data.tax;
          this.purchase.additional_cost = response.data.data.additional_cost;
          this.purchase.total_price = response.data.data.total_price;
          this.purchase.vendor = response.data.data.vendor_name;
          this.purchase.date = response.data.data.created_at;
        });
    },
    getDetailsPurchaseItem() {
      const id = this.$route.params.id;
      this.$http
        .get("warehouse/receiving/" + id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          var datas = response.data.data;
          var i;
          const { baseUrl } = $themeConfig.app;
          for (i = 0; i < datas.length; i++) {
            this.photo = baseUrl;
            this.photo += "storage/product/";
            this.photo += datas[i].product_image;
            // console.log(this.photo)
            var $data = {
              image: this.photo,
              item_id: datas[i].item_id,
              name: datas[i].product_name,
              qty: datas[i].qty,
              unit_name: datas[i].unit_name,
            };
            // console.log($data)
            this.rows.push($data);
          }
        });
    },
    getDetailsTransfer() {
      this.$http
        .get("warehouse/transfer/" + this.detail.ref_id)
        .then((response) => {
          // console.log(response.data.data)
          this.transfer.code = response.data.data.code;
          this.transfer.warehouse_origin =
            response.data.data.warehouse_origin_name;
          this.transfer.warehouse_destination =
            response.data.data.warehouse_destination_name;
          this.transfer.description = response.data.data.description;
          this.transfer.date = response.data.data.created_at;
        });
    },
    getDetailsTransferItem() {
      const id = this.$route.params.id;
      this.$http
        .get("warehouse/receiving/" + id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          var datas = response.data.data;
          var i;
          const { baseUrl } = $themeConfig.app;
          for (i = 0; i < datas.length; i++) {
            this.photo = baseUrl;
            this.photo += "storage/product/";
            this.photo += datas[i].product_image;
            // console.log(this.photo)
            var $data = {
              image: this.photo,
              item_id: datas[i].item_id,
              name: datas[i].product_name,
              qty: datas[i].qty,
              unit_name: datas[i].unit_name,
            };
            // console.log($data)
            this.rows.push($data);
          }
        });
    },
    getLogs() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/receiving/" + id + "/logs").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            description: datas[i].description,
            qty: datas[i].qty,
            created_at: datas[i].created_at,
            variant: "secondary",
          };
          this.logs.push($data);
        }
      });
    },
    link(url) {
      window.open(url);
    },
    trigger(data) {
      this.getBins();
      this.insert.item_id = data.item_id;
      this.insert.real_qty = data.qty;
      this.insert.qty = null;
      this.insert.selectedBin = null;
      this.insert.type = this.detail.type;
      this.insert.ref_id = this.detail.ref_id;
    },
    getBins() {
      this.$http
        .get("warehouse/" + this.detail.warehouse_id + "/bins")
        .then((response) => {
          // console.log(response.data.data)
          this.insert.selectedBin = null;
          this.insert.optionsBin.splice(0);
          var datas = response.data.data;
          var i;
          for (i = 0; i < datas.length; i++) {
            var $data = {
              value: datas[i].id,
              text: datas[i].name,
            };
            // console.log($data)
            this.insert.optionsBin.push($data);
          }
          // console.log(this.insert.optionsBin)
        });
    },
    insertItemToBin() {
      if (this.insert.selectedBin !== null) {
        var $binID = this.insert.selectedBin.value;
      }
      if (this.insert.qty > this.insert.real_qty) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Qty cant higher then " + this.insert.real_qty,
            variant: "warning",
          },
        });
      } else {
        this.$http
          .post("warehouse/receiving/insert", {
            item_id: this.insert.item_id,
            bin_id: $binID,
            qty: this.insert.qty,
            type: this.insert.type,
            ref_id: this.insert.ref_id,
          })
          .then((response) => {
            // console.log(response.data.data)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Notification",
                icon: "BellIcon",
                text: "Success Insert",
                variant: "success",
              },
            });
            location.reload();
          })
          .catch((errors) => {
            this.errMessage = errors.response.data.message;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Notification",
                icon: "BellIcon",
                text: this.errMessage,
                variant: "warning",
              },
            });
            console.log(errors.response);
          });
      }
    },
    statusProcess() {
      if (this.form.selectedEmployee === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "Assign field is required",
            variant: "warning",
          },
        });
      } else {
        const id = this.$route.params.id;
        this.$http
          .post("warehouse/receiving/" + id + "/process", {
            assign_to: this.form.selectedEmployee.value,
          })
          .then((response) => {
            // console.log(response.data.data)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Notification",
                icon: "BellIcon",
                text: "Status Process",
                variant: "success",
              },
            });
            location.href = "/warehouse/warehouse-receiving";
          });
      }
    },
    statusFinish() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/receiving/" + id + "/finish")
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Finished",
              variant: "success",
            },
          });
          location.href = "/warehouse/warehouse-receiving";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>